import { render, staticRenderFns } from "./DateWidgetInput.vue?vue&type=template&id=72e54b3c&"
import script from "./DateWidgetInput.vue?vue&type=script&lang=js&"
export * from "./DateWidgetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e54b3c')) {
      api.createRecord('72e54b3c', component.options)
    } else {
      api.reload('72e54b3c', component.options)
    }
    module.hot.accept("./DateWidgetInput.vue?vue&type=template&id=72e54b3c&", function () {
      api.rerender('72e54b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/inputs/DateWidgetInput.vue"
export default component.exports